"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.value("$stickyDefaultOptions", {
  width: 600
});
ngModule.directive("stickyDeck", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: '<div class="sticky-deck"></div>',
    controller: function controller($scope, $element) {
      var ctrl = this;
      ctrl.getDeckElement = function () {
        return $element;
      };
    }
  };
});
ngModule.directive("stickyDialog", function ($stickyBox) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    transclude: true,
    template: require("./sticky-dialog.html"),
    controllerAs: "stickyCtrl",
    link: function link($scope, $el, $attrs, ctrl) {
      var options = $scope.dialogOptions;
      ctrl.initialize(options);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        boxContainer = $scope.$container,
        deckCtrl = $scope.$deckCtrl,
        $el = $element,
        state = {
          minimized: false,
          lastPosition: null
        };
      var updateIndex = function updateIndex() {
        $el.css("z-index", $stickyBox.incrementIndex());
      };
      ctrl.initialize = function (options) {
        updateIndex();
        $el.click(updateIndex);
        $el.width(options.width);
        $el.draggable({
          scroll: false,
          containment: "parent",
          appendTo: boxContainer,
          handle: ".dialog-header .title",
          start: function start(event, ui) {
            updateIndex();
          }
          // stack : 'dialog-selectors'
        });
        ctrl.centerInContainer();
      };
      ctrl.centerInContainer = function () {
        var width = $el.width(),
          height = $el.height(),
          containerWidth = boxContainer.width(),
          containerHeight = boxContainer.height(),
          widthDifference = containerWidth - width,
          heightDifference = containerHeight - height;
        $el.css({
          left: widthDifference / 2 + "px",
          top: heightDifference / 2 + "px"
        });
      };
      ctrl.isMinimized = function () {
        return state.minimized;
      };
      ctrl.closeDialog = function () {
        $scope.$close();
      };
      ctrl.minimizeDialog = function () {
        if (state.minimized) {
          return;
        }
        state.lastPosition = $el.position();
        $el.draggable("disable");
        $el.css({
          top: "",
          left: "",
          right: "",
          bottom: ""
        });
        $el.appendTo(deckCtrl.getDeckElement());
        state.minimized = true;
      };
      ctrl.maximizeDialog = function () {
        if (!state.minimized) {
          return;
        }
        state.minimized = false;
        $el.css({
          top: state.lastPosition.top,
          left: state.lastPosition.left,
          right: null,
          bottom: null
        });
        updateIndex();
        $el.appendTo($scope.$container);
        $el.draggable("enable");
      };
      ctrl.toggleDialog = function () {
        if (state.minimized) {
          ctrl.maximizeDialog();
        } else {
          ctrl.minimizeDialog();
        }
      };
      $scope.$on("$destroy", function () {
        $el.draggable("destroy");
      });
    }
  };
});
ngModule.factory("$stickyBox", function ($compile, $animate, $rootScope, $window, $q, $controller, $body, keyCodes, deferredUtils, templateUtils, directiveUtils, $stickyDefaultOptions) {
  var deck = null,
    deckCtrl = null,
    deckScope = null,
    openedDialogs = [],
    currentIndex = 500;

  // deck

  var createDeck = function createDeck() {
    if (deckScope != null) {
      return;
    }
    var deckLink = directiveUtils.compileDirective("stickyDeck");
    deckScope = $rootScope.$new();
    deckLink(deckScope, function (_deckEl) {
      deck = _deckEl;
      deck.appendTo($body);
    });
    deckCtrl = deck.controller("stickyDeck");
  };

  // dialog

  var openDialog = function openDialog(dialog) {
    if (deck == null) {
      createDeck();
      dialog.scope.$deckCtrl = deckCtrl;
    }
    return createDialog(dialog);
  };
  var createDialog = function createDialog(dialog) {
    var dialogEl = $('<sticky-dialog>');
    dialogEl.html(dialog.template);
    $compile(dialogEl)(dialog.scope, function (clone) {
      dialog.element = clone;
      openedDialogs.push(dialog);
      (dialog.container || $body.find(".main-wrapper")).append(clone);
    });
    return dialog.element;
  };
  var closeDialog = function closeDialog(dialog) {
    var dialogIndex = _.indexOf(openedDialogs, dialog);
    openedDialogs.splice(dialogIndex, 1);
    if (openedDialogs.length === 0) {
      currentIndex = 500; // reseting
    }
    dialog.scope.$destroy();
    dialog.element.remove();
  };
  var $stickyBox = {
    incrementIndex: function incrementIndex() {
      return currentIndex++;
    },
    open: function open(dialogOptions) {
      var dialogResultDeferred = $q.defer(),
        dialogResultPromise = dialogResultDeferred.promise;
      dialogOptions.resolve = dialogOptions.resolve || {};
      dialogOptions.options = _.extend({}, $stickyDefaultOptions, dialogOptions.options || {});
      _.extend(dialogOptions.options, {
        title: dialogOptions.title || ""
      });

      // verify options
      if (!dialogOptions.template && !dialogOptions.templateUrl) {
        throw new Error('One of template or templateUrl options is required.');
      }
      var resolvesPromise = deferredUtils.resolvePromiseMap(dialogOptions.resolve),
        templatePromise = templateUtils.loadTemplate(dialogOptions);
      $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
        var locals = resolves[0],
          template = resolves[1],
          dialogScope = (dialogOptions.scope || $rootScope).$new(),
          dialogId = _.uniqueId("$dialog-");
        var dialog = {
          id: dialogId,
          options: dialogOptions,
          scope: dialogScope,
          deferred: dialogResultDeferred,
          promise: dialogResultPromise,
          template: template,
          container: $body.find(".main-wrapper"),
          resolve: locals
        };
        if (dialogOptions.vars) {
          _.extend(dialogScope, dialogOptions.vars);
        }
        _.extend(dialogScope, {
          $dialogId: dialogId,
          $container: dialog.container,
          $deckCtrl: deckCtrl,
          dialogOptions: dialogOptions.options || {},
          $close: function $close(value) {
            closeDialog(dialog);
            dialogResultDeferred.resolve(value);
          },
          $dismiss: function $dismiss(reason) {
            closeDialog(dialog);
            dialogResultDeferred.reject(reason);
          }
        });
        dialog.element = openDialog(dialog);
        _.extend(locals, {
          $element: dialog.element
        });

        // controller
        if (dialogOptions.controller) {
          locals.$scope = dialogScope;
          locals.$dialog = dialog;
          dialog.ctrl = $controller(dialogOptions.controller, locals);
        }
      });
      return dialogResultPromise;
    }
  };
  return $stickyBox;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/dialogs/$stickyBox.js
// module id = 2931
// module chunks = 13